export default __webpack_public_path__ + "static/media/Aura-Egg__33.7bfefc01.png";